import * as React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const ModalFooter = ({ children, className, ...rest }: Props) => {
  return (
    <Footer {...rest} className={className}>
      {children}
    </Footer>
  );
};

const Footer = styled.div`
  background-color: ${({ theme }) => theme.colors.elevated};
  display: flex;
`;

export default ModalFooter;
